<div class="contenido">
    <ng-container *ngIf="(esTestEpayco)">
        <h2 class="text-2xl font-bold text-center">¡Modo de pruebas!</h2>
    </ng-container>
    <h2 class="text-2xl font-bold text-center">¡Completa tu pago!</h2>
    <p class="text-center">Para hacer efectiva tu consulta, te invitamos a completar el pago.</p>
    <div class="contenido-button">
        <button
        class="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800"
        (click)="pagar()">
        <span
            class="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
            Pagar
        </span>
    </button>
    </div>
</div>